import { SettingsLayout } from "@mbits/mray-react-common";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/settings")({
  component: SettingsLayout,
});
